import { t } from "@/i18n";

// Bloque de coste estimado y presupuesto disponible unificado para todos los modelos.
// priceType: "fixed" = precio publicado; "token_estimate" = aproximado por tokens;
//            "not_available" = precio no encontrado en docs consultadas.
const CostEstimate = ({
  total,
  reserve,
  budgetAvailable,
  extraRefCost,
  priceType,
  priceVerified = true,
  pricePending = false,
}) => {
  if (total == null && budgetAvailable == null && reserve == null && priceVerified !== false && !pricePending && priceType !== "not_available") {
    return null;
  }

  const isUnverified = (
    priceVerified === false ||
    pricePending === true ||
    priceType === "not_available" ||
    (total == null && priceType !== "token_estimate")
  );

  const fmtBudget = (v) =>
    v != null
      ? `US$${Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : null;

  const fmtCost = (v) =>
    v != null
      ? `US$${Number(v).toLocaleString("en-US", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`
      : null;

  return (
    <div data-testid="cost-estimate" className="space-y-1 text-[11px] text-[#a3a3a3]">
      {budgetAvailable != null && (
        <p data-testid="cost-budget-available">
          <span className="text-[#a3a3a3]">{t.tools?.costBudgetAvailable ?? "Presupuesto disponible"}:</span>{" "}
          <span className="text-[#ededed] font-medium">{fmtBudget(budgetAvailable)}</span>
        </p>
      )}

      <p data-testid="cost-total">
        <span className="text-[#a3a3a3]">{t.tools?.costEstimateTitle ?? "Coste estimado"}:</span>{" "}
        {isUnverified ? (
          <span className="font-medium text-amber-400" data-testid="cost-unverified-badge">
            {t.models?.unverifiedBadge ?? "Precio no verificado"}
          </span>
        ) : (
          <>
            <span className="text-[#ededed] font-medium">{fmtCost(total)}</span>
            {priceType === "token_estimate" && (
              <span className="ml-1 text-[10px] text-[#a3a3a3] italic">
                ({t.tools?.costTokenEstimate ?? "estimado por tokens"})
              </span>
            )}
          </>
        )}
      </p>

      {reserve != null && !isUnverified && (
        <p data-testid="cost-reserve" className="text-[10px] text-[#8e8e8e]">
          <span className="text-[#8e8e8e]">Reserva preventiva:</span>{" "}
          <span className="font-mono text-[#ededed]">{fmtCost(reserve)}</span>{" "}
          <span className="text-[#666]">(ajuste real al finalizar)</span>
        </p>
      )}

      {extraRefCost != null && extraRefCost > 0 && !isUnverified && (
        <p data-testid="cost-extra-ref" className="text-[10px] text-[#7a7a7a]">
          + {fmtCost(extraRefCost)} por ref. adicional
        </p>
      )}
    </div>
  );
};

export default CostEstimate;
